import style from '../CreditOnboardingEgyptLuckyV1/CreditOnboardingEgyptLuckyV1.css';
import TextField from '../../shared/TextField/TextField';
import Button from '../../shared/Button/Button';
import useTranslation from '../../../localization/i18n.context';
import Title from '../../shared/Typography/Title';
import { useState, useEffect } from 'preact/hooks';

const StepField = {
  REQUESTED_CREDIT_LIMIT: 'requestedCreditLimit',
};

export default function RequestedCreditLimitStep({
  onInputChange,
  data = {},
  stepNumber,
  stepCount,
}) {
  const [selectedValue, setSelectedValue] = useState(null);
  const { t } = useTranslation();
  const isButtonEnabled = Object.values(StepField).every(
    field => data[field] && data[field].value && data[field].value?.trim(),
  );

  useEffect(() => {
    updateSelectedValues(data);
  }, [data]);

  function updateSelectedValues(formData) {
    if (formData[StepField.REQUESTED_CREDIT_LIMIT]) {
      setSelectedValue(
        formData[StepField.REQUESTED_CREDIT_LIMIT].value ?? null,
      );
    }
  }

  return (
    <main className={style.main}>
      <div className={style['form-content']}>
        <div className={style['form-header']}>
          <p className={style['form-header-title']}>
            {t(`STEP {step_number}/{step_count}`, {
              '{step_number}': stepNumber,
              '{step_count}': stepCount,
            })}
          </p>
        </div>
        <div className={style['form-title']}>
          <Title text={t("What's your requested credit limit?")} />
        </div>
        <div className={style['form-inputs']}>
          <div className={style['form-control']}>
            <TextField
              label={t('Amount')}
              placeholder={t('Enter amount')}
              inputMode="numeric"
              onInput={onInputChange}
              name={StepField.REQUESTED_CREDIT_LIMIT}
              value={selectedValue}
            />
          </div>
        </div>
      </div>
      <div className="fixed-cta">
        <Button fullWidth disabled={!isButtonEnabled}>
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
RequestedCreditLimitStep.Type = 'RequestedCreditLimitStep';
RequestedCreditLimitStep.EventName = 'requested_credit_limit_step';
